import { useId, useState, type ReactNode } from 'react'

import './facts.css'

/**
 * A list behind a show/hide button: the facts a digest cites, the figures an
 * alert was raised on. The list is in the DOM but `hidden` until opened, so
 * the button's `aria-controls` always names an element.
 */
export function Disclosure({
  showLabel,
  hideLabel,
  listLabel,
  children,
}: {
  /** The button while closed, e.g. "Show the figures (2)". */
  showLabel: string
  hideLabel: string
  /** The list's accessible name. */
  listLabel: string
  /** The list's `<li>` items. */
  children: ReactNode
}) {
  const [open, setOpen] = useState(false)
  const panelId = useId()
  return (
    <div className="ci-facts">
      <button
        type="button"
        className="ci-button"
        data-variant="ghost"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((value) => !value)}
      >
        {open ? hideLabel : showLabel}
      </button>
      <ul id={panelId} className="ci-facts__list" aria-label={listLabel} hidden={!open}>
        {children}
      </ul>
    </div>
  )
}
